import React, { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { setSystemFormButtonSave } from '../../../../redux/action/system'
import Button from '../Button'
import CircleLoader from '../../loaders/CircleLoader'

const FormButtonSave = React.memo(({ updateMode = false, zIndex, onClick, disabled, keyButton, disableProccesing = false, icon = 'save', customTitle }) => {
	const { t } = useTranslation()
	const isProcessing = useSelector(state => state.system.formButtonSave.processing)
	const isSuccess = useSelector(state => state.system.formButtonSave.success)
	const formChangedModal = useSelector(state => state.system.formChangedModal)
	const showIsSuccess = isSuccess && !disableProccesing
	const dispatch = useDispatch()
	const buttonTitle = customTitle || t('buttons.controls.save')

	useEffect(() => {
		if (showIsSuccess) {
			if (formChangedModal) {
				dispatch(setSystemFormButtonSave({ success: !isSuccess }))
			} else {
				setTimeout(() => {
					dispatch(setSystemFormButtonSave({ success: !isSuccess }))
				}, 3000)
			}
		}
	}, [showIsSuccess, isSuccess, formChangedModal]) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		return () => dispatch(setSystemFormButtonSave({
			processing: false,
			success: false,
		}))
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	const handleClick = useCallback(() => {
		if (!showIsSuccess) {
			onClick()
		}
	}, [showIsSuccess, onClick])

	return (
		<>
			{(isProcessing && !disableProccesing) ?
				<Button name="processing-saving"
								color="gray-light"
								testId="processing-saving"
								keyButton={keyButton || 'F2'}
								text={t('buttons.controls.saving')}>
					<CircleLoader />
				</Button> :
				<Button name={updateMode ? 'update' : 'save'}
								testId={updateMode ? 'button-update' : 'button-save'}
								color={showIsSuccess ? 'blue' : 'green'}
								icon={showIsSuccess ? 'checkmark' : icon}
								keyButton={keyButton || 'F2'}
								text={showIsSuccess ? t('buttons.controls.succesSaved') : (updateMode ? t('buttons.controls.update') : buttonTitle)}
								zIndex={zIndex}
								disabled={disabled}
								onClick={handleClick} />}
		</>
	)
})


FormButtonSave.displayName = 'FormButtonSave'
export default FormButtonSave

